export const API_PATHS = {
  cases: '/api/cases',
  staff: '/api/staff',
  tasks: '/api/tasks',
  schedule: '/api/schedule',
  allocations: '/api/allocations',
  reflect: '/api/simulation/reflect',
  reflections: '/api/simulation/reflections',
  login: '/api/auth/login',
  me: '/api/auth/me',
  logout: '/api/auth/logout',
  accounts: '/api/accounts',
  scheduleMilestones: '/api/schedule/milestones',
  scheduleWorkingGroups: '/api/schedule/working-groups',
} as const;

const seg = (value: string): string => encodeURIComponent(value);

/** パスパラメータ付きのパス。ID は必ずエンコードする。 */
export const apiPath = {
  taskById: (id: string): string => `${API_PATHS.tasks}/${seg(id)}`,
  caseById: (id: string): string => `${API_PATHS.cases}/${seg(id)}`,
  staffById: (id: string): string => `${API_PATHS.staff}/${seg(id)}`,
  scheduleRow: (taskId: string): string => `${API_PATHS.schedule}/rows/${seg(taskId)}`,
  accountById: (id: string): string => `${API_PATHS.accounts}/${seg(id)}`,
  accountPassword: (id: string): string => `${API_PATHS.accounts}/${seg(id)}/password`,
  allocationPair: (staffId: string, caseId: string): string =>
    `${API_PATHS.staff}/${seg(staffId)}/allocations/${seg(caseId)}`,
} as const;
